
const postTableItem = Vue.component('post-table-item', {

    props: ['post', 'type'],
    
    template: `
    <tr class="c-references-item">
        <td class="c-references-item-img-wrapper">
            <div class="o-img-1/1">
                <img v-bind:src="post.thumbnail" class="c-references-item-img" alt="">
            </div>
        </td>
        <td class="c-references-item-content">
            <div class="c-references-item-meta"><span>{{ new Date(post.date).getFullYear() }}</span><span v-for="cat in post.categories">{{ cat.name }}</span></div>
            <h6 class="c-references-item-title" v-html="post.title.rendered"></h6>
            <div v-html="post.excerpt.rendered" class="c-references-item-excerpt"></div>
        </td>
        <td class="c-references-item-link"><a v-bind:href="post.link" class="o-link">{{ type }} <svg><use xlink:href="#arrow-right"></use></svg></a></td>
    </tr>`
});

export default postTableItem;